/* eslint-disable*/

import PropTypes from 'prop-types';
import Accordian from './accordion';

const MobileComponent = ({
  newScore,
  item,
  viva,
  handleChange,
  expand,
  cultureScore,
  localSupply,
  publicTransport,
  selectedLayer,
}) => (
  <div>
    <Accordian
      type="wohnlage"
      item={item}
      handleChange={handleChange}
      viva={viva}
      newScore={newScore}
      expand={expand}
      selectedLayer={selectedLayer}
    />
    <Accordian
      type="opnv"
      item={item}
      handleChange={handleChange}
      viva={viva}
      newScore={publicTransport}
      expand={expand}
      selectedLayer={selectedLayer}
    />
    <Accordian
      type="kultur"
      item={item}
      handleChange={handleChange}
      viva={viva}
      newScore={cultureScore}
      expand={expand}
      selectedLayer={selectedLayer}
    />
    <Accordian
      type="Nahversorgung"
      item={item}
      handleChange={handleChange}
      viva={viva}
      newScore={localSupply}
      expand={expand}
      selectedLayer={selectedLayer}
    />
  </div>
);

MobileComponent.propTypes = {
  item: PropTypes.object,
  newScore: PropTypes.number,
  viva: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  expand: PropTypes.any,
  cultureScore: PropTypes.number,
  localSupply: PropTypes.number,
  publicTransport: PropTypes.number,
};

MobileComponent.defaultProps = {
  item: { id: 'string' },
  newScore: 0,
  expand: false,
  cultureScore: 0,
  localSupply: 0,
  publicTransport: 0,
};

export default MobileComponent;
